import Divider from 'components/Divider';
import Modal from 'components/shared/Modal';
import { creditStore } from 'entities/credit';

export const NotEnoughSecondsModal = () => {
  const { isNotEnoughSecondsModal, setNotEnoughSecondsModal } = creditStore(
    (state) => ({
      isNotEnoughSecondsModal: state.isNotEnoughSecondsModal,
      setNotEnoughSecondsModal: state.setNotEnoughSecondsModal
    })
  );

  return (
    <Modal
      open={isNotEnoughSecondsModal}
      setOpen={(value) => setNotEnoughSecondsModal(!!value)}
      className="!ag-w-[24rem]"
      noPadding
    >
      <div className="yep_ex-text-center">
        <h3 className="yep_ex-text-lg yep_ex-font-semibold yep_ex-py-5">
          Not Enough Seconds
        </h3>
        <Divider />
        <div className="yep_ex-p-4">
          <p className="yep_ex-text-sm yep_ex-text-gray-700">
            You do not have enough Seconds.
            <br />
            Your plan does not support automatic second top-up.
          </p>
        </div>
      </div>
    </Modal>
  );
};
